var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12 col-md-9 col-lg-7 col-xl-6" },
      [
        _c("ob1-message-alerte", {
          attrs: {
            title: _vm.title,
            text: _vm.text,
            "link-href": _vm.linkHref,
            "link-label": _vm.linkLabel,
            type: "info",
            "with-arrow-link": true,
            "is-simple-alerte": false,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }